/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   selectorsRoot.ts
 */

import type { State } from '@zcode/state-type'

export const selectRoot = (state: State) => state
